import React from 'react';
import { RatePlanProperty, RoomRatePlan } from 'app/state';
import { NumberCellInput } from './number-cell-input';

export function MealPlanFeeColumn(
  isAvailable: (plan: RoomRatePlan) => boolean,
  getValue: (plan: RoomRatePlan) => number,
  onChange: (plan: RoomRatePlan, value: number | undefined) => void
) {
  return [
    {
      title: 'Meal Plan Cost',
      align: 'center' as const,
      colSpan: 1.2,
      valueFactory: (plan: RoomRatePlan) =>
        // an invalid value stays visible even when meals are off: it still blocks Save until fixed or cleared.
        isAvailable(plan) || getValue(plan) < 0 ? (
          <NumberCellInput
            value={getValue(plan)}
            onChange={value => onChange(plan, value)}
            error={getValue(plan) < 0}
            helperText={getValue(plan) < 0 ? 'Value cannot be less than zero' : undefined}
            aria-label={`Meal plan cost for ${(plan as RatePlanProperty).propertyName}`}
            data-testid="ratePlanRowMealPlanFeeInput"
          />
        ) : (
          '--'
        ),
    },
  ];
}
